import React from 'react'

import PropTypes from 'prop-types'

import './button-outline1.css'

const ButtonOutline1 = (props) => {
  return (
    <div
      id={props.buttonOutlineId}
      className={`button-outline1-container ${props.rootClassName} `}
    ></div>
  )
}

ButtonOutline1.defaultProps = {
  buttonOutlineId: '',
  rootClassName: '',
}

ButtonOutline1.propTypes = {
  buttonOutlineId: PropTypes.string,
  rootClassName: PropTypes.string,
}

export default ButtonOutline1
